import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

export function Lightbox({ src, onClose, alt = "" }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  if (!src) return null;
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 backdrop-blur-sm p-4"
      onClick={onClose}
      data-testid="lightbox"
    >
      <button
        className="absolute top-4 right-4 w-11 h-11 rounded-md bg-white/10 hover:bg-white/20 text-white flex items-center justify-center border border-white/20"
        onClick={onClose}
        data-testid="lightbox-close"
      >
        <X className="w-5 h-5" />
      </button>
      <img
        src={src}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
        className="max-w-[95vw] max-h-[92vh] object-contain rounded shadow-2xl"
      />
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-xs text-white/60 font-mono tracking-widest uppercase">
        ESC ile kapat
      </div>
    </div>
  );
}

export function useLightbox() {
  const [src, setSrc] = useState(null);
  return { src, open: (s) => setSrc(s), close: () => setSrc(null) };
}
